var _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIconCheckCircleFill = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  "data-name": "Layer 1",
  viewBox: "0 0 22 22"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 11,
  cy: 11,
  r: 11,
  className: "icon-check-circle-fill_svg__cls-1"
})), /*#__PURE__*/React.createElement("path", {
  d: "M8.79 16.06a1 1 0 0 0 1.42 0l7.17-7.17a1.24 1.24 0 1 0-1.76-1.76L9.5 13l-3.12-2.88a1.24 1.24 0 1 0-1.76 1.76Z",
  style: {
    fill: "#fff",
    fillRule: "evenodd"
  }
}));
export default SvgIconCheckCircleFill;